module.exports = __webpack_public_path__ + "img/digitali_farm_ikon.694014e3.png";